import { Step } from "react-joyride";

export const tourStepsTimedTrials = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Timed Trials is a race through a collection. Finish as fast as you can, then compare times.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Pick a collection, choose whose name goes on the board, then start. Players can take turns on the same device.",
    },
    {
      target: ".collections-overview",
      content:
        "Select the collection to race. Everyone who plays that collection shares the same local leaderboard.",
    },
    {
      target: ".player-name-options",
      content:
        "Use your account name, or type a guest name so another student can race without switching accounts.",
    },
    {
      target: ".start-button",
      content:
        "Start the trial, then advance through items. When you finish, your time is saved. Next Player sets up the following racer.",
    },
  ];

  return steps;
};
